// components/ChangePasswordDialog.tsx
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { Eye, EyeOff, KeyRound } from "lucide-react";

const PasswordField = ({
    value,
    onChange,
    placeholder,
    show,
    setShow,
}: {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
    show: boolean;
    setShow: (v: boolean) => void;
}) => (
    <div className="relative">
        <Input
            type={show ? "text" : "password"}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className="pr-10"
        />
        <button
            type="button"
            className="absolute right-4 top-2.5 text-muted-foreground"
            onClick={() => setShow(!show)}
            tabIndex={-1}
        >
            {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
    </div>
);

export const ChangePassword = () => {

    const [open, setOpen] = useState(false);

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleSubmit = () => {
        // Llogjika për ndryshim fjalëkalimi këtu (API call)
        setOpen(false);
    };

    return (
        <>
            <Button variant="outline" onClick={() => setOpen(true)}>
                <KeyRound className="w-4 h-4 mr-2" />
                Change Password
            </Button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="sm:max-w-md">
                    <DialogHeader>
                        <DialogTitle>Change Password</DialogTitle>
                        <DialogDescription>
                            Enter your current password and choose a new one.
                        </DialogDescription>
                    </DialogHeader>
                    <div className="grid gap-4 py-4">
                        <PasswordField
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Current password"
                            show={showCurrent}
                            setShow={setShowCurrent}
                        />
                        <PasswordField
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="New password"
                            show={showNew}
                            setShow={setShowNew}
                        />
                        <PasswordField
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                            show={showConfirm}
                            setShow={setShowConfirm}
                        />
                    </div>
                    <DialogFooter>
                        <Button onClick={handleSubmit}>Update Password</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
};
